module.exports = __webpack_public_path__ + "img/30-Chêne Gris.jpg";